'use client';

import React, { useState } from 'react';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';
import AuthBrandPanel from './AuthBrandPanel';
import AppLogo from '@/components/ui/AppLogo';

export type AuthTab = 'login' | 'signup';

export default function AuthClient() {
  const [activeTab, setActiveTab] = useState<AuthTab>('login');

  return (
    <div className="flex justify-center w-full bg-slate-100">
      <div className="min-h-screen flex bg-background w-full max-w-[430px] shadow-xl overflow-y-auto">
      {/* Brand Panel — hidden on mobile */}
      <div className="hidden lg:flex lg:w-[45%] xl:w-[40%] flex-shrink-0">
        <AuthBrandPanel />
      </div>

      {/* Form Panel */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 sm:px-10 py-12 overflow-y-auto">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="lg:hidden flex items-center gap-2 mb-8 justify-center">
            <AppLogo size={36} />
            <span className="font-bold text-foreground text-xl tracking-tight">Kasnimo</span>
          </div>

          {/* Tab switcher */}
          <div className="flex rounded-2xl bg-muted p-1 mb-8">
            <button
              onClick={() => setActiveTab('login')}
              className={`flex-1 py-2.5 rounded-xl text-sm font-semibold transition-all duration-200 ${
                activeTab === 'login'
                  ? 'bg-card text-foreground shadow-card'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              Sign In
            </button>
            <button
              onClick={() => setActiveTab('signup')}
              className={`flex-1 py-2.5 rounded-xl text-sm font-semibold transition-all duration-200 ${
                activeTab === 'signup'
                  ? 'bg-card text-foreground shadow-card'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              Create Account
            </button>
          </div>

          {/* Forms */}
          <div className="fade-in">
            {activeTab === 'login' ? (
              <LoginForm onSwitchToSignup={() => setActiveTab('signup')} />
            ) : (
              <SignUpForm onSwitchToLogin={() => setActiveTab('login')} />
            )}
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}
